import React, { useState, useEffect } from 'react';
import axios from 'axios';


function CertificateButton({ contestId, certificateType = 'contest-register' }) {
  const [loading, setLoading] = useState(false);
  const [certificateId, setCertificateId] = useState(null);
  const [error, setError] = useState(null);

  // Check if user has a certificate for this contest
  useEffect(() => {
    const checkCertificate = async () => {
      try {
        const response = await axios.get('/api/certificates');
        if (response.data && response.data.certificates) {
          // Find certificate for this contest and type
          const cert = response.data.certificates.find(c => 
            c.referenceId === contestId && c.certificateType === certificateType
          );
          
          if (cert) {
            setCertificateId(cert.id);
          }
        }
      } catch (err) {
        console.error('Error checking certificates:', err);
        // Silent fail - no need to show error for this check
      }
    };
    
    if (contestId) {
      checkCertificate();
    }
  }, [contestId, certificateType]);

  // Generate certificate if needed
  const generateCertificate = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Generate certificate
      const response = await axios.post('/api/certificates/generate-contest-registration', {
        contestId
      });
      
      if (response.data && response.data.certificateId) {
        const newCertificateId = response.data.certificateId;
        setCertificateId(newCertificateId);
        
        // Auto-download the generated certificate
        const pdfResponse = await axios.get(`/api/certificates/${newCertificateId}`, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/pdf'
          }
        });
        
        // Create a blob URL and download
        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `CampApex-Certificate-${newCertificateId}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }
    } catch (err) {
      console.error('Error generating/downloading certificate:', err);
      setError('Unable to generate certificate. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Download the certificate
  const downloadCertificate = async () => {
    if (!certificateId) return;
    
    setLoading(true);
    try {
      // Request the PDF as a blob
      const response = await axios.get(`/api/certificates/${certificateId}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      });
      
      // Create a blob URL for the PDF
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      
      // Create a link and click it to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `CampApex-Certificate-${certificateId}.pdf`);
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error downloading certificate:', err);
      setError('Failed to download the certificate. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // If we don't have a certificate ID yet, show generate button
  if (!certificateId) {
    return (
      <div className="mt-4">
        <button
          onClick={generateCertificate}
          disabled={loading}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {loading ? 'Generating...' : 'Generate Certificate (to share with others)'}
        </button>
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      </div>
    );
  }

  // If we have a certificate ID, show download button
  return (
    <div className="mt-4">
      {/* <button
        onClick={downloadCertificate}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      >
        Download Certificate
      </button> */}
    </div>
  );
}

export default CertificateButton;